module.exports = __webpack_public_path__ + "img/photo16.694566c8.jpg";